import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import "./VoucherCertificate.css";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const VoucherCertificate = ({
  showVoucherCertificate,
  setShowVoucherCertificate,
  voucherCertificateData,
}) => {
  const [timestamp, setTimestamp] = useState(0);
  const [startTimestamp, setStartTimestamp] = useState(0);

  const voucherIsExpired = () => {
    if (
      voucherCertificateData &&
      voucherCertificateData.codes.at(-1).toTimestamp < timestamp
    ) {
      if (
        voucherCertificateData &&
        voucherCertificateData.codes.at(-1).toTimestamp + 30 < timestamp
      ) {
        setShowVoucherCertificate(false);
      }
      return true;
    }
    return false;
  };

  const dismissIsEnabled = () => {
    return startTimestamp + 3 < timestamp;
  };

  const codeColor = (code) => {
    if (code.fromTimestamp < timestamp && code.toTimestamp >= timestamp)
      return { color: "white" };
    else if (
      code.fromTimestamp < timestamp + 30 &&
      code.toTimestamp >= timestamp + 30
    )
      return { color: "#a5c3b0" };
    else if (
      code.fromTimestamp < timestamp - 30 &&
      code.toTimestamp >= timestamp - 30
    )
      return { color: "#a5c3b0" };
    else return { color: "" };
  };

  useEffect(() => {
    setStartTimestamp(parseInt(Date.now() / 1000));
  }, [voucherCertificateData]);

  useEffect(() => {
    const interval = setInterval(
      () => setTimestamp(parseInt(Date.now() / 1000)),
      1000
    );
    return () => clearInterval(interval);
  }, []);

  return (
    <Modal
      className="voucher-certificate-modal voucher-certificate-modal-header voucher-certificate-modal-footer"
      show={showVoucherCertificate}
      fullscreen="md-down"
      onHide={() => setShowVoucherCertificate(false)}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>Gutschein Verifikation</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        {voucherCertificateData && (
          <div>
            <div>DIESER GUTSCHEIN IST GÜLTIG FÜR</div>
            <motion.div
              animate={{
                rotate: [0, 1, 0, -1, 0],
              }}
              transition={{
                duration: 0.5,
                repeat: Infinity,
              }}
            >
              <h1 className="text-white mx-5">
                {voucherCertificateData.title}
              </h1>
            </motion.div>
            <div className="mt-5">KONTROLLNUMMERN</div>
            {voucherCertificateData.codes.map((code) => (
              <h1 key={code.code} style={codeColor(code)}>
                {code.code}
              </h1>
            ))}
            {voucherIsExpired() && (
              <h1>
                <Badge pill bg="danger">
                  ! ABGELAUFEN !
                </Badge>
              </h1>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="success"
          onClick={() => setShowVoucherCertificate(false)}
          disabled={!dismissIsEnabled()}
        >
          {voucherIsExpired() ? (
            <div>Abbrechen</div>
          ) : (
            <div>Bezug abgeschlossen</div>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VoucherCertificate;
